/* eslint-disable no-unused-vars,no-restricted-syntax,guard-for-in */
import * as ActionTypes from '../actions/types/SeatingChartActionTypes';

const initialState = {
  busy: false,
  byEventId: {},
  seatingChart: {},
  tablesByUuid: {},
  tables: [],
  seatsByUuid: {},
  seatsByTableUuid: {},
  listView: true,
  isDetailed: false
};

const chartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_CHART: {
      return { ...state, busy: true };
    }
    case ActionTypes.RECEIVE_CHART: {
      const seatingChart = action.payload.data;
      const seatingChartTables = seatingChart.tables;
      const tablesByUuid = {};
      const seatsByUuid = {};
      const seatsByTableUuid = {};
      const tables = [];
      if (seatingChartTables.length > 0) {
        seatingChartTables.forEach((table) => {
          const newTable = table;

          const seatViews = table.seats;
          newTable.num_filled_seats = seatViews.length;

          const tableSeats = Array(table.num_seats).fill(null);
          if (seatViews.length > 0) {
            seatViews.forEach((seat) => {
              seatsByUuid[seat.uuid] = seat;
              tableSeats[seat.display_order - 1] = seat;
            });
          }

          // Fill in empty seats if necessary
          for (let i = 0; i < table.num_seats; i += 1) {
            if (tableSeats[i] == null) {
              tableSeats[i] = { table_uuid: table.uuid, display_order: i + 1, empty: true, uuid: i };
            }
          }

          seatsByTableUuid[table.uuid] = tableSeats;
          newTable.seats = tableSeats;
          tables.push(newTable);
          tablesByUuid[table.uuid] = newTable;
        });
      }
      return Object.assign(
        {},
        state,
        { busy: false },
        { seatingChart, tablesByUuid, seatsByUuid, tables, seatsByTableUuid }
      );
    }
    case ActionTypes.REQUEST_CHARTS: {
      return { ...state, busy: true };
    }
    case ActionTypes.RECEIVE_CHARTS: {
      const seatingCharts = action.payload;
      const byEventId = seatingCharts.event_to_charts_map;
      return Object.assign(
        {},
        state,
        { busy: false },
        { byEventId }
      );
    }
    case ActionTypes.CREATE_TABLE: {
      const tables = [];
      return Object.assign(
        {},
        state,
        { tables }
      );
    }
    case ActionTypes.CHANGE_VIEW: {
      const listView = !state.listView;
      return Object.assign(
        {},
        state,
        { listView }
      );
    }
    case ActionTypes.SHOW_DETAILS: {
      const isDetailed = !state.isDetailed;
      return Object.assign(
        {},
        state,
        { isDetailed }
      );
    }
    case ActionTypes.REQUEST_TABLES: {
      return { ...state, busy: true };
    }
    case ActionTypes.RECEIVE_TABLES: {
      return Object.assign(
        {},
        state,
        { busy: false },
      );
    }
    case ActionTypes.REORDER_TABLES: {
      const tables = state.tables.slice();
      if (tables.length <= 0) {
        return Object.assign(
          {},
          state,
          { busy: false });
      }

      const sourceIndex = action.payload.sourceIndex;
      const hoverIndex = action.payload.hoverIndex;

      const direction = (hoverIndex > sourceIndex) ? 1 : -1;
      let index = sourceIndex;
      while (index !== hoverIndex) {
        tables[index] = state.tables[index + direction];
        index += direction;
      }

      tables[hoverIndex] = state.tables[sourceIndex];

      const tablesByUuid = {};

      tables.forEach((table) => {
        tablesByUuid[table.uuid] = table;
      });

      return Object.assign(
        {},
        state,
        { busy: false },
        { tables, tablesByUuid }
      );
    }
    case ActionTypes.REORDER_SEATS: {
      const table = { ...state.tablesByUuid[action.payload.tableUuid] };
      if (table == null) {
        return Object.assign(
          {},
          state,
          { busy: false });
      }
      const sourceIndex = action.payload.sourceIndex;
      const hoverIndex = action.payload.hoverIndex;

      const seats = table.seats.slice();
      if (seats.length > 0) {
        const direction = (hoverIndex > sourceIndex) ? 1 : -1;
        let index = sourceIndex;
        while (index !== hoverIndex) {
          seats[index] = table.seats[index + direction];
          index += direction;
        }

        seats[hoverIndex] = table.seats[sourceIndex];
      }

      table.seats = seats;

      const tables = [];
      const tablesByUuid = {};
      for (let i = 0; i < state.tables.length; i += 1) {
        if (state.tables[i].uuid === table.uuid) {
          tables[i] = table;
          tablesByUuid[table.uuid] = table;
        } else {
          tables[i] = state.tables[i];
          tablesByUuid[state.tables[i].uuid] = state.tables[i];
        }
      }

      return Object.assign(
        {},
        state,
        { busy: false },
        { tables, tablesByUuid },
      );
    }
    default: return state;
  }
};

export default chartReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/seatingChart.js
 **/